import React from "react";
import {
  formatCurrencyAmount,
  getCurrencyGlyph,
  normalizeCurrencyCode,
} from "../utils/currencyUtils";

const PayoutStatusCard = ({
  userBalance,
  pendingBalance = 0,
  minCashout,
  performcashOut,
  loading = false,
  currency = "USD",
}) => {
  const currencyCode = normalizeCurrencyCode(currency);
  const currencyGlyph = getCurrencyGlyph(currencyCode);

  const getDaysLeft = () => {
    const today = new Date();
    const lastDay = new Date(
      today.getFullYear(),
      today.getMonth() + 1,
      0,
    ).getDate();
    return lastDay - today.getDate();
  };

  const daysLeft = getDaysLeft();
  const available = parseFloat(userBalance) || 0;
  const pending = parseFloat(pendingBalance) || 0;
  const minimum = parseFloat(minCashout) || 0;
  const canCashOut = minimum > 0 ? available > minimum : available > 0;

  return (
    <div className="seller-dashboard__payout-card h-100">
      <div className="seller-dashboard__payout-header">
        <div
          className="seller-dashboard__payout-icon"
          title={currencyCode}
          aria-label={`Currency ${currencyCode}`}
        >
          <span className="seller-dashboard__currency-glyph" aria-hidden="true">
            {currencyGlyph}
          </span>
        </div>
        <div>
          <p className="seller-dashboard__payout-label mb-1">Payout Status</p>
          <h3 className="seller-dashboard__payout-title mb-0">
            {daysLeft} day{daysLeft !== 1 ? "s" : ""} until auto payout
          </h3>
        </div>
      </div>

      <p className="seller-dashboard__payout-copy mb-0">
        Funds stay in your Stripe balance until you cash out. Only available
        balance can be sent to your bank — pending funds clear after Stripe
        processing.
      </p>

      <div className="seller-dashboard__balance-split">
        <div className="seller-dashboard__balance-row">
          <span className="seller-dashboard__balance-meta">
            <span
              className="seller-dashboard__balance-dot seller-dashboard__balance-dot--available"
              aria-hidden="true"
            />
            <span className="seller-dashboard__payout-balance-label">
              Available ({currencyCode})
            </span>
          </span>
          <strong className="seller-dashboard__payout-balance">
            {formatCurrencyAmount(userBalance, currencyCode)}
          </strong>
        </div>
        <div className="seller-dashboard__balance-row">
          <span className="seller-dashboard__balance-meta">
            <span
              className="seller-dashboard__balance-dot seller-dashboard__balance-dot--pending"
              aria-hidden="true"
            />
            <span className="seller-dashboard__payout-balance-label">
              Pending ({currencyCode})
            </span>
          </span>
          <strong className="seller-dashboard__payout-balance seller-dashboard__payout-balance--pending">
            {formatCurrencyAmount(pending, currencyCode)}
          </strong>
        </div>
      </div>

      <div className="seller-dashboard__payout-footer">
        <button
          type="button"
          className="seller-dashboard__btn seller-dashboard__btn--primary w-100"
          disabled={!canCashOut || loading}
          onClick={performcashOut}
        >
          {loading ? "Processing..." : "Cash out available balance"}
        </button>
      </div>

      {!canCashOut && minCashout != null && minCashout !== "" && (
        <p className="seller-dashboard__payout-hint mb-0">
          Minimum available balance of{" "}
          {formatCurrencyAmount(minCashout, currencyCode)} required to cash out.
        </p>
      )}
      {!canCashOut && available <= 0 && pending > 0 && (
        <p className="seller-dashboard__payout-hint mb-0">
          You have pending funds that are not yet available for payout.
        </p>
      )}
    </div>
  );
};

export default PayoutStatusCard;
